import React, { Component } from "react";
import { Link } from "react-router-dom";
import Content from "../../content/Content";
import Store from "./../../content/Store";
import styles from "../../assets/css/modules/myprofile/myprofile.css";
import { Paths } from "./../../constants/UrlConstants";
import MemberHelper from "./../../helpers/MemberHelper";
import commonStyles from "../../assets/css/modules/myprofile/change-profile-common.css";

export default class AddAPlanSuccess extends Component {
  getPhoneNumber = (policy) => {
    let phoneNumber =
      policy &&
      policy.PolicyServicingTelephones &&
      policy.PolicyServicingTelephones.TelephonePolicyServicing;

    return phoneNumber || "";
  };

  getSummaryContent = (policy) => {
    if (policy.IsLapsed) {
      return null;
    }
    if (
      (policy.IsFormat2 && !policy.IsHealthSelect) ||
      policy.IsSME ||
      policy.IsLargeCorporate ||
      !MemberHelper.getCurrentLoggedInMemberFromPolicy(policy).IsPolicyHolder
    ) {
      return Store.AddAPlanSuccess.SuccessSummarySmeLCorpDep;
    }
    return Store.AddAPlanSuccess.SuccessSummaryLiveIndividual;
  };

  render() {
    let phoneNumber = this.getPhoneNumber(this.props.policy);
    let planSuccessSummaryContent = this.getSummaryContent(this.props.policy);
    return (
      <div>
        <div
          className={"alert alert-success mt-2 " + styles.messages}
          role="alert"
        >
          <p>
            <Content name={Store.AddAPlanSuccess.SuccessMessage} />
          </p>
        </div>
        {planSuccessSummaryContent ? (
          <Content
            name={planSuccessSummaryContent}
            params={{ phoneNumber: phoneNumber }}
          />
        ) : null}

        <div className="pt-3">
          <Link
            to={Paths.ChooseYourPlan}
            id="btnViewOtherPlans"
            className={styles.actionButton + " " + styles.actionButtonPrimary}
          >
            <Content name={Store.AddAPlanSuccess.ButtonViewOtherPlans} />
          </Link>
        </div>
        <div className={commonStyles.actionButtons}>
          <div className="col-sm-6 back-button">
            <Link id="goBackLink" to="#" onClick={this.props.onBackClick}>
              <span className="mr-2 left-arrow-back">←</span>{" "}
              <Content name={Store.ChangeProfileCommon.BackButtonLabel} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
